// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentProcessing_container__38i8Y {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #0D0E11;
  overflow: hidden;
  /* overflow-x: hidden;
  overflow-y: auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Background Gradient SVG */
.paymentProcessing_backgroundGradient__zoa\\+3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.paymentProcessing_bottomLeftSvg__Rvzqy {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  /* min-width: 360px;
  min-height: 621px; */
  z-index: 0;
  pointer-events: none;
}

.paymentProcessing_backgroundSvg__FwBHS {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

/* Main Content */
.paymentProcessing_content__Exmed {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 100%;
  max-width: 360px;
  padding: 0 16px;
  margin-bottom: 88px;
}

/* Icon */
.paymentProcessing_iconContainer__E3kyu {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 46px;
}

.paymentProcessing_icon__WbIRj {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

/* Title */
.paymentProcessing_title__A4Td3 {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: #F3F4F6;
  text-align: center;
  margin: 0;
  margin-bottom: 16px;
}

/* Subtitle */
.paymentProcessing_subtitle__Q6UE1 {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #C1C3CF;
  text-align: center;
  margin: 0;
  width: 256px;
  max-width: 90%;
}

/* Retry Button */
.paymentProcessing_retryButton__niJow {
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 296px;
  max-width: calc(100% - 64px);
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0D0E11;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: #C1C3CF;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}

.paymentProcessing_retryButton__niJow:hover {
  background-color: #1A1B1F;
  border-color: rgba(255, 255, 255, 0.3);
}

.paymentProcessing_retryButton__niJow:active {
  transform: translateX(-50%) scale(0.98);
}

/* Responsive */
@media (max-width: 360px) {
  .paymentProcessing_content__Exmed {
    max-width: 100%;
  }

  .paymentProcessing_retryButton__niJow {
    width: calc(100% - 64px);
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/PaymentProcessing/paymentProcessing.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB;qBACmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,YAAY;EACZ;sBACoB;EACpB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  background-color: #0D0E11;\n  overflow: hidden;\n  /* overflow-x: hidden;\n  overflow-y: auto; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Background Gradient SVG */\n.backgroundGradient {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.bottomLeftSvg {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* min-width: 360px;\n  min-height: 621px; */\n  z-index: 0;\n  pointer-events: none;\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n/* Main Content */\n.content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  width: 100%;\n  max-width: 360px;\n  padding: 0 16px;\n  margin-bottom: 88px;\n}\n\n/* Icon */\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 46px;\n}\n\n.icon {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n}\n\n/* Title */\n.title {\n  font-family: 'Inter', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #F3F4F6;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 16px;\n}\n\n/* Subtitle */\n.subtitle {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #C1C3CF;\n  text-align: center;\n  margin: 0;\n  width: 256px;\n  max-width: 90%;\n}\n\n/* Retry Button */\n.retryButton {\n  position: fixed;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 296px;\n  max-width: calc(100% - 64px);\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0D0E11;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #C1C3CF;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.retryButton:hover {\n  background-color: #1A1B1F;\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.retryButton:active {\n  transform: translateX(-50%) scale(0.98);\n}\n\n/* Responsive */\n@media (max-width: 360px) {\n  .content {\n    max-width: 100%;\n  }\n\n  .retryButton {\n    width: calc(100% - 64px);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `paymentProcessing_container__38i8Y`,
	"backgroundGradient": `paymentProcessing_backgroundGradient__zoa+3`,
	"bottomLeftSvg": `paymentProcessing_bottomLeftSvg__Rvzqy`,
	"backgroundSvg": `paymentProcessing_backgroundSvg__FwBHS`,
	"content": `paymentProcessing_content__Exmed`,
	"iconContainer": `paymentProcessing_iconContainer__E3kyu`,
	"icon": `paymentProcessing_icon__WbIRj`,
	"title": `paymentProcessing_title__A4Td3`,
	"subtitle": `paymentProcessing_subtitle__Q6UE1`,
	"retryButton": `paymentProcessing_retryButton__niJow`
};
export default ___CSS_LOADER_EXPORT___;
